import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DiscountRoutingModule } from './discount-routing.module';
import { CreateDiscountComponent } from './create-discount/create-discount.component';
import { EditDiscountComponent } from './edit-discount/edit-discount.component';
import { ViewDiscountComponent } from './view-discount/view-discount.component';
import { DiscountListComponent } from './discount-list/discount-list.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ArchwizardModule } from 'angular-archwizard';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    CreateDiscountComponent,
    EditDiscountComponent,
    ViewDiscountComponent,
    DiscountListComponent
  ],
  imports: [
    CommonModule,
    DiscountRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgxDatatableModule,
    PipeModule,
    NgbModule,
    NgSelectModule,
    NgxSpinnerModule,
  ]
})
export class DiscountModule { }
